import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-20 bg-stone-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8 text-stone-900" style={{ fontFamily: '"Playfair Display", serif' }}>
            Terms of Service
          </h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6 text-stone-700">
            <p className="text-sm text-stone-500">Last Updated: December 2024</p>
            
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">1. Acceptance of Terms</h2>
              <p>
                By accessing and using Roaffees' website, café services, or purchasing our products, you agree to be bound 
                by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">2. Products and Services</h2>
              <p className="mb-3">
                Roaffees offers premium coffee, matcha, and related products both in our café and through our online platform. 
                We reserve the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modify or discontinue products without prior notice</li>
                <li>Limit quantities of products available for purchase</li>
                <li>Refuse service to anyone for any reason</li>
                <li>Update prices at any time without prior notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">3. Orders and Payment</h2>
              <p className="mb-3">
                When you place an order with us:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>All orders are subject to acceptance and availability</li>
                <li>We reserve the right to refuse or cancel any order</li>
                <li>Payment must be made in full at the time of purchase</li>
                <li>Prices are in Indian Rupees (INR) and include applicable taxes</li>
                <li>You are responsible for providing accurate billing and delivery information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">4. Delivery and Pickup</h2>
              <p className="mb-3">
                For delivery orders:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Delivery times are estimates and not guaranteed</li>
                <li>Delivery is available within specified areas of Delhi</li>
                <li>Delivery fees may apply based on location and order value</li>
                <li>You must be available to receive the delivery at the specified address</li>
              </ul>
              <p className="mt-3">
                For café pickup orders, please collect your order within the specified timeframe to ensure freshness.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">5. Returns and Refunds</h2>
              <p className="mb-3">
                Due to the nature of our food and beverage products:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>We do not accept returns on consumed products</li>
                <li>Refunds are provided only for defective or incorrect orders</li>
                <li>Claims must be made within 24 hours of purchase or delivery</li>
                <li>Refunds will be processed to the original payment method within 7-10 business days</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">6. Product Information</h2>
              <p>
                We strive to provide accurate product descriptions, ingredients, and allergen information. However, we cannot 
                guarantee that all information is error-free. If you have allergies or dietary restrictions, please inform our 
                staff before ordering. We are not liable for allergic reactions or dietary issues resulting from consumption of 
                our products.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">7. Café Conduct</h2>
              <p className="mb-3">
                When visiting our café, you agree to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respect other customers and our staff</li>
                <li>Follow all posted rules and staff instructions</li>
                <li>Not engage in disruptive or inappropriate behavior</li>
                <li>Take responsibility for any damage to café property</li>
              </ul>
              <p className="mt-3">
                We reserve the right to refuse service or ask anyone to leave who violates these standards.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">8. Intellectual Property</h2>
              <p>
                All content on our website, including text, images, logos, and designs, is the property of Roaffees and 
                protected by copyright and trademark laws. You may not use, reproduce, or distribute any content without 
                our written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">9. Limitation of Liability</h2>
              <p>
                Roaffees shall not be liable for any indirect, incidental, special, or consequential damages arising from 
                your use of our services or products. Our total liability shall not exceed the amount you paid for the 
                product or service in question.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">10. Events and Promotions</h2>
              <p>
                Special events, promotions, and offers are subject to specific terms and conditions. These will be communicated 
                at the time of the event or promotion. We reserve the right to modify or cancel events and promotions at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">11. Governing Law</h2>
              <p>
                These Terms of Service are governed by the laws of India. Any disputes arising from these terms shall be 
                subject to the exclusive jurisdiction of the courts in New Delhi, India.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon 
                posting on our website. Your continued use of our services after changes are posted constitutes acceptance of 
                the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-stone-900">13. Contact Information</h2>
              <p className="mb-3">
                For questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-stone-50 p-4 rounded-lg">
                <p className="font-semibold text-stone-900">Roaffees</p>
                <p>Connaught Place, New Delhi, India</p>
                <p>Email: info@roaffees.com</p>
                <p>Phone: +91 11 1234 5678</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
